/**
 * Security API
 * Civilization Security API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface RoleDto { 
    id?: number;
    name?: string;
    description?: string;
    permissions?: Array<RoleDto.PermissionsEnum>;
    version?: number;
    createdDate?: Date;
    lastModifiedDate?: Date;
}
export namespace RoleDto {
    export type PermissionsEnum = 'READ_USER' | 'READ_USERS' | 'READ_GAME' | 'WRITE_GAME' | 'WRITE_SIMPLE_ENGINE';
    export const PermissionsEnum = {
        READUSER: 'READ_USER' as PermissionsEnum,
        READUSERS: 'READ_USERS' as PermissionsEnum,
        READGAME: 'READ_GAME' as PermissionsEnum,
        WRITEGAME: 'WRITE_GAME' as PermissionsEnum,
        WRITESIMPLEENGINE: 'WRITE_SIMPLE_ENGINE' as PermissionsEnum
    };
}